export default function menuBarDirective(MenuService, $window, User, $firebase, environment){
  'ngInject';
  return {
    restrict: 'E',
    transclude: true,
    scope: true,
    templateUrl: 'app/components/menu/menuBar.html',
    link: function($scope, $element){

      $scope.userService = User;

      $scope.showNotification = false;
      $scope.showMenu = false;
      $scope.unseenNoty = false;
      $scope.isAdmin = false;
      $scope.baseUrl = environment.site.parent;
      $scope.newUrl = environment.site.new;

      $scope.notificationData = [];
      $scope.menuShows = [];
      $scope.menuCategories = [];

      $scope.hoverSubMenu = (menuItem) => {
        $scope.activeMenu = menuItem;
      }

      $scope.toggleNotification = () => {
        if ($scope.unseenNotification) {
          let viewedNoty = [];
          for (let key in $scope.notificationData) {
            viewedNoty.push({
              entity_id: $scope.notificationData[key].id,
              type: "shows",
              show_id: $scope.notificationData[key].show_id
            });
          }
          MenuService.postViewedNotification(viewedNoty);
          $scope.unseenNotification = 0;
        }

        if ($scope.showNotification) {
          $scope.showNotification = false;
          $scope.viewedNotification = ["shows"];
          $scope.notificationData.forEach(item => {
              item.unseen = false;
          });
        } else {
          $scope.showNotification = true;
        }
      }

      $scope.navigateLink = (notification) => {
        let sliceLInk = notification.link.split("/");
        let url = `${$scope.newUrl}/shows/${sliceLInk[sliceLInk.length-3]}/${sliceLInk[sliceLInk.length-2]}/${sliceLInk[sliceLInk.length-1]}`;
        $window.location.href = url;
      }

      $scope.isExist = (noty) => {
        if ($scope.viewedNotification && $scope.viewedNotification.length) {
          return false;
        } else {
          return true;
        }
      }

      $scope.toggleMenu = () => {
        if ($scope.showMenu) {
          $scope.showMenu = false;
        } else {
          $scope.showMenu = true;
        }
      }

      $scope.hideNotification = () => {
        $scope.showNotification = false;
        $scope.notificationData.forEach(item => {
            item.unseen = false;
        });
        $scope.unseenNotification = 0;
      }

      $scope.$watch(() => {
          return User.loggedIn();
        },
        function () {
          MenuService.getViewedNotification().then(res => {
            $scope.viewedNotification = res.data.items;

            // connect to database
            var rootRef = firebase.database().ref('bethel/notifications/shows');
            rootRef.on('value', function(snapshot) {
              notification(snapshot.val());
            });
          });

          User.getUser().then(res => {
            if (res) {
              $scope.isAdmin = res.is_admin;
            }
          });
        });

      $scope.closeMenu = () => {
        $scope.showMenu = false;
      }

      function notification(notyItems) {
        for (let key in notyItems) {
          $scope.notificationData.push(notyItems[key]);
        }
        let viewedNotification = [];
        let unViewedNotification = [];
          if ($scope.viewedNotification[0]) {
            $scope.viewedNotification.forEach(viewed => {
              if (!viewed.deleted) {
                $scope.notificationData.filter(item => {
                  if (item.id == viewed.entity_id) {
                    viewedNotification.push(item);
                    item.unseen = false;
                  }
                });
                unViewedNotification = $scope.notificationData.filter(item => {
                  if (!~viewedNotification.indexOf(item)) {
                    item.unseen = true;
                    return item;
                  }
                });
              }
            });
          } else {
            unViewedNotification = $scope.notificationData;
          }
          $scope.unseenNotification = unViewedNotification.length;

          if (viewedNotification[0]) {
            viewedNotification.sort(compareNotyfication);
          }
          if(unViewedNotification[0]) {
            unViewedNotification.sort(compareNotyfication);
          }

        $scope.sortedNotification = unViewedNotification.concat(viewedNotification);
      }

      function compareNotyfication(item1, item2) {
        if (item1.date > item2.date) return -1;
        if (item1.date < item2.date) return 1;
      }

      function compareSubcategory(item1, item2) {
        if (item1.display_order < item2.display_order) return -1;
        if (item1.display_order > item2.display_order) return 1;
      }
    }
  };
}



/** WEBPACK FOOTER **
 ** ./src/app/components/menu/menuBar.directive.js
 **/